import React from 'react';
import { history } from 'umi';

import styles from './styles.scss';
import allIcon from '@/assets/grid_all.png';
import gridHyzx from '@/assets/grid_hyzx.png';

export default (props) => {

  const { items,onClick } = props;

  return(
    <div className={styles.grid_box}>

      <GridItem item={{image: gridHyzx}} onClick={()=>{
        history.push('/home/memberList');
      }}/>

      {items.map((item,i) => (<GridItem key={i+''} item={item} onClick={()=> {
        history.push({pathname:'/home/courseList',state:{title:item.name ,categoryId:item.id}})
      }}/>))}

      <GridItem item={{image:allIcon}} onClick={()=>{
        history.push('/home/category');
      }}/>
    </div>
  )
}


const GridItem = (props) => {
  const { item } = props;

  return (
   <div className={styles.grid_item} onClick={props.onClick}>
      <img className={styles.grid_img} alt='' src={item.image}/>
   </div>
  )
}
